(function () {
    'use strict';

    a3_cabin_reports.factory('PhiloxeniaQuestionsFactory', PhiloxeniaQuestionsFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name PhiloxeniaQuestionsFactory
     * @ngInject
     */
    function PhiloxeniaQuestionsFactory(GenericService) {
        function PhiloxeniaQuestions() {
            this.FlightId = null;
            this.Questions = null;
            this.RepliesCounter = 0;

		}

        var objType ='philoxeniaQuestions';
		var objCallback = PhiloxeniaQuestions; 
        
        var ratingQuestions = [{Option: 1, OptionText: "Basic", Counter: 0, Percentage: null},
                                {Option: 2, OptionText: "Basic +", Counter: 0, Percentage: null},
                                {Option: 3, OptionText: "Expected", Counter: 0, Percentage: null},
                                {Option: 4, OptionText: "Expected +", Counter: 0, Percentage: null},
                                {Option: 5, OptionText: "Excellent", Counter: 0, Percentage: null} ];

        var service = {
            updatePhiloxeniaQuestionsToStorage : updatePhiloxeniaQuestionsToStorage,
            getFlightPhiloxeniaQuestionsFromStorage : getFlightPhiloxeniaQuestionsFromStorage,
            cleanOldData: cleanOldData
        };

         /**
         * Get Philoxenia Questions.
         * @memberof PhiloxeniaQuestionsFactory
         * @returns {Array} PhiloxeniaQuestions 
         */
		function getPhiloxeniaQuestionsFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Save Philoxenia Questions to storage
         * @memberof PhiloxeniaQuestionsFactory
         * @param {Array} PhiloxeniaQuestions
         */
		function setPhiloxeniaQuestionsToStorage(objList) {
			GenericService.saveAll(objList,objType);
        }

        /**
         * Update Philoxenia Questions for specified flight
         * @memberof PhiloxeniaQuestionsFactory
         * @param {} PhiloxeniaQuestions questions for a flight
         * @returns {Array} PhiloxeniaQuestions
         */
        function updatePhiloxeniaQuestionsToStorage(philoxeniaQuestions){
            //Get all PhiloxeniaQuestions exept current flight from storage
            var storedPhiloxeniaQuestions = getPhiloxeniaQuestionsFromStorage();
            var storedPhiloxeniaQuestionsFiltered = storedPhiloxeniaQuestions.filter(f=> f != null && f.FlightId != philoxeniaQuestions.FlightId);
            //Add Philoxenia Questions for the current flight
            if(philoxeniaQuestions){
                //get AVG value for Rating questions
                philoxeniaQuestions.Questions.forEach(function(question){
                        if(question.QuestionInfo.Type == "RATING"){
                            //Get Option List
                            var optionList = [];
                            ratingQuestions.forEach(function(option){
                                var currentAnswer = question.AnswerCounters.filter(f=> f.OptionId == option.Option);
                                if(currentAnswer.length>0 && philoxeniaQuestions.RepliesCounter>0){
                                    option.Counter = currentAnswer[0].Counter;
                                    option.Percentage = (currentAnswer[0].Counter / philoxeniaQuestions.RepliesCounter)*100;
                                }
                                optionList.push(option);
                            })
                            question.OptionList = optionList;

                            //Get AVG value
                            var value = 0;
                            var weight = 0;
                            question.AnswerCounters.forEach(function(answer){
                                value += +answer.TextValue * answer.Counter;
                                weight += answer.Counter;
                            })
                            if(weight > 0){
                                question.AVG = value / weight;
                            }
                        }
                        else{
                            var selectedOptionIds = question.AnswerCounters.map(function(v){
                                return v.OptionId;
                                });

                            //get AnswerCounter for selections with zero counter
                            var optionsZeroCounter = question.QuestionInfo.Options.filter(x => !selectedOptionIds.includes(x.Id));
                            var optionsZeroCounterMapper = optionsZeroCounter.map(function(a){
                                return {OptionId:a.Id, TextValue:a.Value, Counter:0}
                            })

                            question.AnswerCounters = question.AnswerCounters.concat(optionsZeroCounterMapper);
                            question.AVG = 0;
                        }
                    });
                    //Get only questions with answers
                    philoxeniaQuestions.Questions = philoxeniaQuestions.Questions.filter(f=>f.AnswerCounters && f.AnswerCounters.length>0);
                    
                storedPhiloxeniaQuestionsFiltered.push(philoxeniaQuestions);
                //save PhiloxeniaQuestions
                setPhiloxeniaQuestionsToStorage(storedPhiloxeniaQuestionsFiltered);
            }
        }

        /**
         * Get Philoxenia Questions for specified flight
         * @memberof PhiloxeniaQuestionsFactory
         * @param {number} flightId
         * @returns {Array} PhiloxeniaQuestions
         */
		function getFlightPhiloxeniaQuestionsFromStorage(flightId) {
			var storedPhiloxeniaQuestions = getPhiloxeniaQuestionsFromStorage();
            if(storedPhiloxeniaQuestions){
                var flightPhiloxeniaQuestions = storedPhiloxeniaQuestions.filter(x => x != null && x.FlightId == flightId);
                return flightPhiloxeniaQuestions[0];
            }else{
                return null;
            }
            
		}


         /**
         * Clean ls from old flights Philoxenia Questions
         * @param {array} flights Synced flights
         */
          function cleanOldData(responseFlightIds){
            var previousPhiloxeniaQuestions = getPhiloxeniaQuestionsFromStorage();
            
            //Filter out Philoxenia Questions of old flights
            previousPhiloxeniaQuestions = previousPhiloxeniaQuestions.filter(x => x != null && responseFlightIds.includes(x.FlightId));
            
            setPhiloxeniaQuestionsToStorage(previousPhiloxeniaQuestions);
        }

        return service;
    }
})();